"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = formatNumberWithString;
const deconstruct_number_format_1 = require("./deconstruct-number-format");
const format_number_1 = __importDefault(require("./format-number"));
function formatNumberWithString(value, requiredFormat, overrideOptions) {
    let deconstructedFormat;
    if (requiredFormat) {
        deconstructedFormat = (0, deconstruct_number_format_1.deconstructNumberFormat)(requiredFormat.trim());
    }
    value = (value === null ? '' : value);
    value = value + '';
    value = value.length ? value.trim() : '';
    let format;
    if (deconstructedFormat) {
        format = (0, format_number_1.default)({
            negativeType: deconstructedFormat.negativeType,
            negativeLeftSymbol: deconstructedFormat.negativeLeftSymbol,
            negativeRightSymbol: deconstructedFormat.negativeRightSymbol,
            negativeLeftOut: deconstructedFormat.negativeLeftPos === 0,
            negativeRightOut: deconstructedFormat.negativeRightPos === 0,
            prefix: deconstructedFormat.prefix,
            suffix: deconstructedFormat.suffix,
            integerSeparator: deconstructedFormat.integerSeparator,
            decimalsSeparator: deconstructedFormat.decimalsSeparator,
            decimal: deconstructedFormat.decimalChar,
            padLeft: deconstructedFormat.padLeft,
            padRight: deconstructedFormat.padRight,
            round: deconstructedFormat.maxRight,
            truncate: undefined
        });
    }
    else {
        format = (0, format_number_1.default)({
            negativeLeftOut: false,
            negativeRightOut: false,
            truncate: undefined
        });
    }
    return format(value, overrideOptions);
}
//# sourceMappingURL=format-number-with-string.js.map